module.exports = __webpack_public_path__ + "img/india_nz.dd4d9c63.jpg";